export const initPendo = () => {
  // @ts-expect-error Import works correctly
  // eslint-disable-next-line import/no-internal-modules
  import('features/analytics-scripts/scripts/pendo');
};
